import {UAParser} from "ua-parser-js";

class UserAgentParser extends UAParser {
  constructor(uastring) {
    super(uastring);
  }
  osString() {
    const device = this.getOS();
    const props= Object.values(device).filter((p) => p);
    return props.length ? props.join(" ") : "";
  }
  browser() {
    const browser = this.getBrowser();
    const props= Object.values(browser).filter((p) => p);
    return props.length ? props.join(" ") : "";
  }
  short() {
    const device = this.osString();
    const browser = this.browser();
    return device || browser
      ? `${device || "Unknown OS"} ${browser || "Unknown browser"}`
      : this.getUA();
  }
}

export default function userAgentParser(uastring) {
  return new UserAgentParser(uastring);
}
